/** Kartlägger diagramnyckel (subSlide.chart) till presentationskomponent. */
export function chartType(chart: string | undefined): string | undefined {
  switch (chart) {
    case 'compass':
      return 'Compass';
    case 'sustainabilityCompass':
      return 'SustainabilityCompass';
    case 'industryCompass':
      return 'IndustryCompass';
    case 'competitorsCompass':
      return 'CompetitorsCompass';
    case 'turnover':
      return 'DynamicColumnChart';
    case 'operatingResult':
      return 'DynamicColumnChart';
    case 'yearResult':
      return 'DynamicColumnChart';
    case 'totalAssets':
      return 'DynamicColumnChart';
    case 'totalDebt':
      return 'DynamicColumnChart';
    case 'equity':
      return 'DynamicColumnChart';
    case 'adjustedEquity':
      return 'DynamicColumnChart';
    case 'operatingCashflow':
      return 'DynamicColumnChart';
    case 'cash':
      return 'DynamicColumnChart';
    case 'workingCapital':
      return 'DynamicColumnChart';
    case 'workingCapitalDelta':
      return 'DynamicColumnChart';
    case 'investmentsCashflow':
      return 'DynamicColumnChart';
    case 'totalCashflow':
      return 'DynamicColumnChart';
    case 'freeCashflow':
      return 'DynamicColumnChart';
    case 'interestBearingLiabilities':
      return 'DynamicColumnChart';
    case 'interestBearingLiabilitiesDelta':
      return 'DynamicColumnChart';
    case 'ownersCashflow':
      return 'DynamicColumnChart';
    case 'financingCashflow':
      return 'DynamicColumnChart';
    case 'operatingMargin':
      return 'DynamicLineChart';
    case 'valueAdded':
      return 'DynamicLineChart';
    case 'returnOnCapital':
      return 'DynamicLineChart';
    case 'returnOnEquity':
      return 'DynamicLineChart';
    case 'solidity':
      return 'DynamicLineChart';
    case 'quickRatio':
      return 'DynamicLineChart';
    case 'netMargin':
      return 'DynamicLineChart';
    case 'freeCashflowOfNetProfit':
      return 'DynamicLineChart';
    case 'operatingCashflowPercent':
      return 'DynamicLineChart';
    case 'workingCapitalPercent':
      return 'DynamicLineChart';
    case 'cashPercent':
      return 'DynamicLineChart';
    case 'interestBearingLiabilitiesPercent':
      return 'DynamicLineChart';
    case 'investmentsCashflowPercent':
      return 'DynamicLineChart';
    case 'ownersCashflowPercent':
      return 'DynamicLineChart';
    case 'dividentYearResultPercent':
      return 'DynamicLineChart';
    case 'dividentCashPercent':
      return 'DynamicLineChart';
    case 'ownerCapitalCashPercent':
      return 'DynamicLineChart';
    case 'profitloss':
      return 'ProfitLoss';
    case 'balance':
      return 'Balance';
    case 'cashflow':
      return 'Cashflow';
    case 'grossMargin':
      return 'DynamicLineChart';
    case 'grossProfit':
      return 'DynamicColumnChart';
    case 'personellCosts':
      return 'DynamicColumnChart';
    case 'grossProfitExPersonellCosts':
      return 'DynamicColumnChart';
    case 'stock':
      return 'DynamicColumnChart';
    case 'otherExternalCosts':
      return 'DynamicColumnChart';
    case 'grossProfitExPersonellCostsPercent':
      return 'DynamicLineChart';
    case 'personellCostsPercent':
      return 'DynamicLineChart';
    case 'stockPercent':
      return 'DynamicLineChart';
    case 'otherExternalCostsPercent':
      return 'DynamicLineChart';
    default:
      return undefined;
  }
}
